import React from 'react';
import { NewLoginProvider } from './NewLoginContext';
import NewLoginContainer from './NewLoginContainer';

const NewLogin = () => {
  return (
    <NewLoginProvider>
      <NewLoginContainer />
    </NewLoginProvider>
  );
};

export default NewLogin;
